<template>
  <header>
    <div class="navbar-btn-menu" @click.stop="changeMenu(true)"><img src="../assets/img/nav-btn.png"></div>
    <div class="nabar-logo"><img src="../assets/img/logo.jpg"></div>
    <div class="navbar-organ"><img src="../assets/img/organ.jpg"></div>
  </header>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  methods: {
    ...mapMutations(["changeMenu"])
  }
};
</script>

<style lang="scss">
@import "../assets/base";

header {
  position: fixed;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  z-index: 100;
  width: 100vw;
  height: 3.25rem;
  padding: 10px 15px;
  background-color: #fff;

  .navbar-btn-menu {
    width: 2rem;
    height: 2rem;
    padding-top: 2px;
    padding-bottom: 3px;
  }

  .nabar-logo {
    width: 9.25rem;
    height: 2rem;
    text-align: center;
  }

  .navbar-organ {
    width: 2rem;
    height: 2rem;
    text-align: right;
  }

  @include img-fluid;
}
</style>
